import { StepEnum } from '../common/interfaces/event';

export const ASSET_STEPS = [
  StepEnum.DATA,
  StepEnum.PHOTO,
  StepEnum.OFFICIAL,
  StepEnum.QRCODE,
  StepEnum.RFID,
  StepEnum.PRIVACY,
  StepEnum.WITNESS,
] as const;

// Probably remove this
export const assetStatuses = ['INFO', 'PHOTO', 'OFFICIALS', 'QRCODE', 'RFID', 'WITNESS', 'MINTED'] as const;

// RFID is intentionally placed here because we currently do not support that step.
export const SKIPPABLE_ASSET_STEPS = [StepEnum.RFID, StepEnum.OFFICIAL, StepEnum.WITNESS, StepEnum.CONFIRM];
export const ASSET_STATUSES = [
  'CREATED',
  'PHOTO_ADDED_STARTED',
  'PHOTO_ADDED_FAILED',
  'PHOTO_ADDED',
  'OFFICIAL_VERIFYING_STARTED',
  'OFFICIAL_VERIFYING_FAILED',
  'OFFICIAL_VERIFIED',
  'QR_BINDING_STARTED',
  'QR_BINDING_FAILED',
  'QR_BOUND',
  'RFID_BINDING_STARTED',
  'RFID_BINDING_FAILED',
  'RFID_BOUND',
  'PRIVACY_STARTED',
  'PRIVACY_FAILED',
  'PRIVACY_DONE',
  'REGISTERING_STARTED',
  'REGISTERING_FAILED',
  'REGISTERED',
  'MINTING_STARTED',
  'MINTING_FAILED',
  'MINTED',
  'INCOMPLETE',
  'COMPLETED',
] as const;

export enum CategoryStatusEnum {
  Normal = 'NORMAL',
  Fixed = 'FIXED',
}
